<template>
    <div class="task-box">
        <div class="left">
            <div class="title">{{ title }}</div>
            <div class="desc">{{ desc }}</div>
            <div class="score">
                <span class="text">限时活力值</span>
                <span class="before-number">+{{ beforeScore }}</span>
                <span class="current-number">+{{ currentScore }}</span>
            </div>
        </div>
        <div class="right">
            <div class="count-down" v-if="taskStatus != 3">
                <span>剩余</span>
                <van-count-down
                    :id="`count-down-value${index}`"
                    :time="countDown"
                    format="HH时mm分ss秒"
                    class="time"
                    @change="handleCountDownChange"
                />
            </div>
            <div
                :class="['button', taskStatus === 3 ? 'cell-butn-gray' : '']"
                @click="handleButtonClick"
            >
                {{ buttonText }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        task: {
            type: Object
        },
        index: {
            type: Number
        }
    },
    data() {
        return {
            time: ''
        };
    },
    computed: {
        title() {
            return this.task.title || '';
        },
        desc() {
            return this.task.desc || '';
        },
        beforeScore() {
            return this.task.score || 0;
        },
        currentScore() {
            return this.task.afterRewardScore || 0;
        },
        buttonText() {
            return this.task.taskButtonText || '';
        },
        countDown() {
            return this.task.countDown || 0;
        },
        taskStatus() {
            return this.task.taskStatus || 0;
        },
        redirectUrl() {
            return this.task.redirectUrl || '';
        }
    },
    methods: {
        handleButtonClick() {
            console.log('time', this.time);
            this.$emit('button-click', this.task, this.index);
        },
        handleCountDownChange(timeData) {
            const { days, hours, minutes, seconds, milliseconds } = timeData;
            const daysToHours = days * 24;
            const m = minutes;
            const h = daysToHours + hours;
            const s = seconds;
            const timeString = `${h}时${m}分${s}秒`;
            this.time = timeString;
        }
    }
};
</script>

<style lang="scss" scoped>
.task-box {
    display: flex;
    justify-content: space-between;
    min-height: 84px;
    padding: 16px 12px 14px 12px;
    background: #ffebe2;
    border-radius: 4px;
    line-height: 1.375;
    .left {
        text-align: left;
        font-size: 10px;
        color: #062f40;
        .title {
            font-size: 15px;
            font-weight: bold;
        }
        .desc {
            margin-top: 2px;
            font-weight: bold;
        }
        .score {
            margin-top: 7px;
            font-weight: bold;
            .text {
            }
            .before-number {
                margin-left: 7px;
                color: #7b6b6b;
                text-decoration-line: line-through;
            }
            .current-number {
                margin-left: 4px;
                color: #ff5a5a;
            }
        }
    }
    .right {
        flex: 0 0 120px;
        text-align: right;
        font-size: 10px;
        font-weight: bold;
        .count-down {
            display: inline-flex;
            justify-content: flex-end;
            align-items: center;
            flex-wrap: wrap;
            word-break: break-all;
            .time {
                margin-left: 2px;
                font-size: 10px;
                color: #f7334b;
                font-weight: bold;
            }
        }
        .button {
            margin-top: 6px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 72px;
            height: 28px;
            font-size: 14px;
            color: #fff;
            background: linear-gradient(90deg, #f09052 0%, #ec6644 100%);
            border-radius: 15px;
            font-weight: bold;
        }
        .cell-butn-gray {
            margin-top: 18px;
            opacity: 0.24;
        }
    }
}
</style>